<template>
  <b-dropdown class="bulk-edit-dropdown" no-caret>
    <template #button-content>
      <b-icon icon="three-dots" font-scale="1"></b-icon>
    </template>
    <b-dropdown-item class="disabled">List actions</b-dropdown-item>
    <b-dd-divider></b-dd-divider>
    <!-- <b-dropdown-item @click="showModal(HANDOVER)"> Handover all cards</b-dropdown-item>  -->
    <b-dropdown-item
      @click="showModal(ARCHIVE)"
      v-if="queueStatus.title === 'Complete'"
      :class="{ disabled: actionsDisabled }"
    >
      Archive all cards</b-dropdown-item
    >
    <!-- <b-dropdown-item @click="showModal(STATUS_CHANGE)"> Change status of all cards</b-dropdown-item>  -->
    <b-dropdown-item
      @click="showModal(DELETE)"
      v-if="isAdmin() || queueStatus.title !== 'Complete'"
      :class="{ 'delete-item': true, disabled: actionsDisabled }"
    >
      Delete all cards</b-dropdown-item
    >
    <b-modal
      body-class="bulk-actions-modal-body"
      hide-header
      hide-footer
      size="md"
      visible
      centered
      v-model="visible"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button @click="closeModal" class="close-button">
        <img
          class="close-icon"
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="closeModal"
        />
      </b-button>

      <div class="title-row primary-dark font-family-medium">
        {{ title }}
      </div>
      <div class="desc-row">
        {{ message }}
      </div>
      <div class="select-row" v-if="action === STATUS_CHANGE">
        <b-form-select :options="statusSelectOptions" 
          text-field="title" 
          value-field="id"
          v-model="selectedStatusId"/>
      </div>
      <div class="select-row" v-if="action === HANDOVER">
        <b-form-select :options="assistantSelectOptions" 
          text-field="name" 
          value-field="profileId"
          v-model="selectedAssistantId"/>
      </div>
      <div class="button-row">
        <div id="submit-button-wrapper">
          <b-button class="btn-delete btn-pill" @click="onButtonClick" :disabled="!buttonEnabled">
            <b-spinner v-if="loading"/>
            <template v-else>
              {{ buttonText }}
            </template>
          </b-button>
          <b-tooltip target="submit-button-wrapper" triggers="hover" v-if="!filtersValid">
            Please enter valid filters
          </b-tooltip>
        </div>
      </div>
    </b-modal>
  </b-dropdown>
</template>
<script>
import { BULK_ACTIONS, BOARDS } from '@/utils/constants'
import { bulkArchive, bulkArchiveCustomerBoard, bulkDelete, bulkDeleteCustomerBoard } from '@/apis/common'
import { isEmpty, validateDates } from '@/utils/utils'
import { isAdmin } from "@/utils/utils";
const { HANDOVER, ARCHIVE, STATUS_CHANGE, DELETE } = BULK_ACTIONS

export default {
    data() {
        return {
          visible: false,
          loading: false,
          selectedAssistantId: null,
          selectedStatusId: null,
          action: ARCHIVE,
          ...BULK_ACTIONS
        }
    },
    mounted() {
      switch(this.board) {
        case BOARDS.CUSTOMER: {
          this.bulkDelete = bulkDeleteCustomerBoard
          this.bulkArchive = bulkArchiveCustomerBoard
        } break
        case BOARDS.MAIN: {
          this.bulkDelete = bulkDelete
          this.bulkArchive = bulkArchive
        } break
        case BOARDS.EA: {
          this.bulkDelete = bulkDelete
          this.bulkArchive = bulkArchive
        } break
        default: {
          this.bulkDelete = bulkDelete
          this.bulkArchive = bulkArchive
        }
      }
    },
    props: {
      statuses: {
        type: Array,
        default() {
          return []
        }
      },
      queueStatus: {
        type: Object, 
        default() {
          return {}
        }
      },
      filters: {
        type: Object, 
        default() {
          return {}
        }
      },
      cardCount: {
        type: Number,
        default() {
          return 0
        }
      },
      assistants: {
        type: Array,
        default() {
          return []
        }
      },
      board: {
        type: String,
        default() {
          return BOARDS.MAIN
        }
      }
    },
    computed: {
      message() {
        let { action } = this
        if (action === HANDOVER) return 'Select an EA to handover the tasks';
        else if (action === ARCHIVE) return 'Do you want to archive all the selected tasks?'
        else if (action === DELETE) return `Do you really want to delete all tasks in ${this.queueStatus.title}? This will remove the tasks from Workspace, including timer entries.`
        else return 'Select the new status from below'
      },
      title() {
        let { action } = this
        if (action === HANDOVER) return 'Handover tasks';
        else if (action === ARCHIVE) return 'Archive Tasks'
        else if (action === DELETE) return 'Delete Tasks'
        else return 'Change Status'
      },
      buttonText() {
        let { action } = this
        if (action === HANDOVER) return 'Handover';
        else if (action === ARCHIVE) return 'Yes, Archive'
        else if (action === DELETE) return 'Delete'
        else return 'Submit'
      },
      showSelect() {
        let { action } = this
        return action === HANDOVER || action === STATUS_CHANGE
      },
      buttonEnabled() {
        if (this.loading) return false
        if (!this.filtersValid) return false

        let { action } = this
        if (action === ARCHIVE) return true
        if (action === DELETE) return true
        else if (action === STATUS_CHANGE) {
          return this.selectedStatusId !== null
        }
        // handover
        return this.selectedAssistantId !== null
      },
      statusSelectOptions() { 
        return [{
          title: 'Select Status',
          id: null
        },
        ...this.statuses.filter(status => status.id !== this.queueStatus.id)
        ]
      },
      assistantSelectOptions() {
        let options = this.assistants.map(assistant => {
          return {
            name: `${assistant.user.firstName} ${assistant.user.lastName}`,
            profileId: assistant.assistantProfile.profile
          }
        })
        return [{
          name: 'Select EA',
          id: null
        }, 
        ...options]
      },
      filtersValid() {
        let { created_gte, created_lte } = this.filters
        return validateDates(created_gte, created_lte)
      },
      actionsDisabled() {
        return this.cardCount === 0
      }
    },
    methods: {
      isAdmin,
      showModal(action) {
        if (this.actionsDisabled) {
          return
        }
        this.action = action
        this.visible = true
      },
      getParams() {
        let params =  {
          status: this.queueStatus.id,
          ...this.filters
        }
        // if there are no date filters then dont send any
        if (isEmpty(this.filters.created_gte)) {
          delete params.created_gte
          delete params.created_lte
        }
        params.is_archive = false
        return params
      },
      async onButtonClick() {
        this.loading = true
        let { action } = this
        let profileId = this.$store.state.authModule.profileUserId

        // if we're on a customer board, then we have to pass the customer id to the API
        if (this.board === BOARDS.CUSTOMER) { 
          profileId = this.$route.params.profileId
        }
        // if we're on a ea board, then we have to pass the ea id to the API
        if (this.board === BOARDS.EA) { 
          profileId = this.$route.params.uuid
        }

        let params = this.getParams()

        try {
          switch(action) {
            case DELETE: {
              let apiResponse = await this.bulkDelete(profileId, params)
              console.log(apiResponse)
            }
            break
            case ARCHIVE: {
              let apiResponse = await this.bulkArchive(profileId, params)
              console.log(apiResponse)
            }
          }
          this.$emit('bulk-action')
        } catch(e) {
          console.log(e)
        } finally {
          this.loading = false
          this.closeModal()
        }
      },
      closeModal() {
        if (this.loading) {
          return
        }
        this.visible = false
      }
    }
}
</script>
<style lang="scss">
@import "~@/scss/variables/colors.scss";
@import "~@/scss/common/fonts.scss";

.bulk-actions-modal-body {
  font-size: $font-size-md;
  padding: 10px;
  > div {
    padding: 10px;
    line-height: normal;
  }
  > .desc-row {
    color: $primary;
    opacity: 0.5;
  }
  > .button-row {
    display: flex;
    button {
      padding: 8px 15px;
    }
  }
  .close-button {
    right: -28px;
    position: absolute;
    display: flex;
    top: -22px;
    background: transparent !important;
  }
}
.bulk-edit-dropdown {
  margin-left: auto;
  ul.dropdown-menu.show {
    border: 1px solid #dcebf4;
    padding: 0 0;
    // box-shadow: -13px 14px 32px 1px rgba(8,11,114,0.19); // 1
    box-shadow: -1px 14px 37px 5px rgba(10, 0, 35, 0.15); // 2
  }
  button.btn.dropdown-toggle {
    background: $card-container-background !important;
    color: $primary;
    font-size: 170%;
    background: $bg--light;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn-secondary:not(:disabled):not(.disabled):active,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: $primary;
  }
  li {
    margin: 0;
    > hr {
      margin: 0;
    }
    > a {
      padding-top: 10px;
      padding-bottom: 10px;
      font-size: 1.5rem;
    }
  }
  li.delete-item {
    > a {
      color: $danger;
    }
  }
  li.disabled {
    > a {
      cursor: default;
      color: $secondary--text;
    }
    > a:hover {
      background: white;
    }
  }
}
</style>
